var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBoardMembers(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 49,
    viewBox: "0 0 47 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3294_26277)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_3294_26277)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.5433 22.8483C25.988 22.8483 27.9687 20.8663 27.9687 18.4236C27.9687 15.9774 25.988 13.9961 23.5433 13.9961C21.0972 13.9961 19.1172 15.9774 19.1172 18.4236C19.1172 20.8662 21.0972 22.8483 23.5433 22.8483Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.4868 25.6305L23.5447 31.5726L17.5652 25.5938C16.2106 26.4361 15.1406 27.9722 15.1406 29.4233V44.2998C15.1406 45.3727 16.0096 46.2416 17.0824 46.2416C17.6091 46.2416 17.0824 46.2416 18.4371 46.2416L19.1756 58.9292C19.1756 60.0705 20.1007 60.9957 21.2427 60.9957C21.7234 60.9957 22.6123 60.9957 23.4994 60.9957C24.387 60.9957 25.2747 60.9957 25.7568 60.9957C26.898 60.9957 27.8225 60.0705 27.8225 58.9292L28.5616 46.2416C29.9163 46.2416 29.3881 46.2416 29.9163 46.2416C30.9883 46.2416 31.8573 45.3727 31.8573 44.2998V29.4232C31.8574 27.9923 30.817 26.48 29.4868 25.6305Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.2188 29.2087L23.5394 30.5294L24.7644 29.3053V26.9219H22.2188V29.2087Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.7646 24.4414H22.2227V26.0705H24.7646V24.4414Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.5164 27.6804C39.6535 27.6804 41.3813 25.9496 41.3813 23.8148C41.3813 21.68 39.6535 19.9492 37.5164 19.9492C35.3823 19.9492 33.6523 21.6799 33.6523 23.8148C33.6523 25.9497 35.3823 27.6804 37.5164 27.6804Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.0452 29.7656L37.4368 34.3733L34.3962 31.3327V44.3006C34.3962 45.5477 33.8803 46.6703 33.0547 47.4831V48.1121L33.6996 59.1914C33.6996 60.1879 34.5087 60.9963 35.5045 60.9963C35.926 60.9963 36.7005 60.9963 37.4758 60.9963C38.2518 60.9963 39.0271 60.9963 39.4471 60.9963C40.4442 60.9963 41.252 60.1879 41.252 59.1914L41.8968 48.1121C43.08 48.1121 42.6196 48.1121 43.08 48.1121C44.0167 48.1121 44.7753 47.3534 44.7753 46.4153V33.4244C44.7752 31.9437 43.5021 30.3651 42.0452 29.7656Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.442 33.3284L38.6525 32.1187V30.5508H36.3281V32.2145L37.442 33.3284Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.6507 28.7031H36.3242V29.7724H38.6507V28.7031Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.47811 27.6804C11.6123 27.6804 13.3422 25.9496 13.3422 23.8148C13.3422 21.68 11.6123 19.9492 9.47811 19.9492C7.34108 19.9492 5.61328 21.6799 5.61328 23.8148C5.61328 25.9497 7.34108 27.6804 9.47811 27.6804Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.5978 31.3327L9.55718 34.3733L4.94879 29.7656C3.49197 30.3651 2.21875 31.9437 2.21875 33.4245V46.4154C2.21875 47.3535 2.97745 48.1122 3.91405 48.1122C4.37442 48.1122 3.91405 48.1122 5.09713 48.1122L5.7421 59.1915C5.7421 60.188 6.54973 60.9964 7.54692 60.9964C7.96698 60.9964 8.74229 60.9964 9.51825 60.9964C10.2936 60.9964 11.0681 60.9964 11.4896 60.9964C12.4854 60.9964 13.2945 60.188 13.2945 59.1915L13.9394 48.1122V47.4832C13.1138 46.6704 12.5979 45.5478 12.5979 44.3006V31.3327H12.5978Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.55418 33.3284L10.6681 32.2145V30.5508H8.34375V32.1187L9.55418 33.3284Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.6703 28.7031H8.34375V29.7724H10.6703V28.7031Z",
    fill: "black"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3294_26277"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 46.5,
    height: 48,
    fill: "white",
    transform: "translate(0.5 0.296875)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_3294_26277"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 47,
    height: 21.1133,
    fill: "white",
    transform: "translate(0 14)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBoardMembers);
export default __webpack_public_path__ + "static/media/boardMembers.153f15e4c03647b61255f2f486215158.svg";
export { ForwardRef as ReactComponent };